import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    container: {
        margin: '15px 10px'
    },
    containerCard: {
        padding: '3.5px 30px',
        minHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '12px !important',
        marginBottom: '22px'
    },
    instanceNameInfo: {
        color: '#acaec2',
        fontSize: theme.palette.textSizeLarge
    },
    instanceInfo: {
        display: 'inline-grid',
        marginTop: '18px'
    },
    overrideGrid: {
        paddingBottom: '2px !important'
    },
    instanceDateInfo: {
        color: '#272727',
        fontSize: theme.palette.textSizeLarge
    },
    serviceContainer: {
        flexGrow: 1,
        marginTop: '5px',
        marginBottom: '12px'
    },
    serviceCard: {
        borderRadius: '12px !important',
        backgroundColor: '#fafbfc !important'
    },
    accountCard: {
        borderRadius: '12px !important',
        minWidth: '165px',
        backgroundColor: '#fafbfc !important'
    },
    serviceCardContent: {
        display: 'block',
        padding: '10px 16px'
    },
    serviceCardStatus: {
        display: 'block',
        borderRadius: '5px !important',
        height: '25px',
        marginBottom: '5px'
    },
    serviceCardTitle: {
        display: 'block',
        fontSize: `${theme.palette.textSizeExtraLarge} !important`,
        marginBottom: '5px',
        marginRight: '10px',
        fontWeight: 600,
        textTransform: 'capitalize'
    },
    accountCardHeading: {
        fontSize: theme.palette.textSizeMedium,
        fontWeight: '800'
    },
    accountCardContent: {
        marginTop: '6px',
        fontSize: theme.palette.textSizeExtraLarge
    }
}));
